<template>
	<input
		id="upload-images-notification"
		accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg, image/jpg"
		hidden
		multiple
		type="file"
		@change="uploadChange"
	/>
	<DaModalFrame v-model:open="modalIsOpen">
		<ExitConfirm
			v-if="modalType === type.DELETE"
			:is-exit="!title || !name"
			@close="exit"
			@back="back"
			@submit="submit"
		/>
	</DaModalFrame>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center"
		>
			<div>
				<div
					class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer"
					@click="$router.push('/fee-notices')"
				>
					<svg
						class="mr-2"
						fill="none"
						height="28"
						viewBox="0 0 28 28"
						width="28"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M4.66671 0C3.37804 0 2.33337 1.04467 2.33337 2.33333V25.6667C2.33337 26.9553 3.37804 28 4.66671 28H23.3334C24.622 28 25.6667 26.9553 25.6667 25.6667V2.33333C25.6667 1.04467 24.622 0 23.3334 0H4.66671ZM9.33337 5.83333C9.33337 5.189 9.85571 4.66667 10.5 4.66667H22.1667C22.811 4.66667 23.3334 5.189 23.3334 5.83333C23.3334 6.47767 22.811 7 22.1667 7H10.5C9.85571 7 9.33337 6.47767 9.33337 5.83333ZM10.5 9.33333C9.85571 9.33333 9.33337 9.85567 9.33337 10.5C9.33337 11.1443 9.85571 11.6667 10.5 11.6667H22.1667C22.811 11.6667 23.3334 11.1443 23.3334 10.5C23.3334 9.85567 22.811 9.33333 22.1667 9.33333H10.5ZM9.33337 15.1667C9.33337 14.5223 9.85571 14 10.5 14H22.1667C22.811 14 23.3334 14.5223 23.3334 15.1667C23.3334 15.811 22.811 16.3333 22.1667 16.3333H10.5C9.85571 16.3333 9.33337 15.811 9.33337 15.1667ZM10.5 18.6667C9.85571 18.6667 9.33337 19.189 9.33337 19.8333C9.33337 20.4777 9.85571 21 10.5 21H22.1667C22.811 21 23.3334 20.4777 23.3334 19.8333C23.3334 19.189 22.811 18.6667 22.1667 18.6667H10.5ZM7.00004 5.83333C7.00004 5.189 6.47771 4.66667 5.83337 4.66667C5.18904 4.66667 4.66671 5.189 4.66671 5.83333C4.66671 6.47767 5.18904 7 5.83337 7C6.47771 7 7.00004 6.47767 7.00004 5.83333ZM5.83337 9.33333C6.47771 9.33333 7.00004 9.85567 7.00004 10.5C7.00004 11.1443 6.47771 11.6667 5.83337 11.6667C5.18904 11.6667 4.66671 11.1443 4.66671 10.5C4.66671 9.85567 5.18904 9.33333 5.83337 9.33333ZM7.00004 15.1667C7.00004 14.5223 6.47771 14 5.83337 14C5.18904 14 4.66671 14.5223 4.66671 15.1667C4.66671 15.811 5.18904 16.3333 5.83337 16.3333C6.47771 16.3333 7.00004 15.811 7.00004 15.1667ZM5.83337 18.6667C6.47771 18.6667 7.00004 19.189 7.00004 19.8333C7.00004 20.4777 6.47771 21 5.83337 21C5.18904 21 4.66671 20.4777 4.66671 19.8333C4.66671 19.189 5.18904 18.6667 5.83337 18.6667Z"
							fill="#94A3B8"
							fill-rule="evenodd"
						/>
					</svg>
					{{ formId ? 'Chỉnh sửa biểu mẫu' : 'Tạo biểu mẫu' }}
				</div>
				<div
					class="uppercase text-sm font-semibold text-green-600 mt-1"
				>
					tạo bởi
					<span class="text-blue-600">{{
						profile?.staff?.name
					}}</span>
					|
					{{ $filters.formatDateTimeNotTz(new Date()) }}
				</div>
			</div>
			<div class="flex items-center justify-end gap-8">
				<button
					class="button-p text-center whitespace-nowrap btn--ghost"
					type="button"
					@click="preview"
				>
					Xem trước
				</button>
				<button
					:disabled="!title || !name"
					class="button-p text-center whitespace-nowrap"
					type="button"
					@click="submit"
				>
					Lưu chỉnh sửa
				</button>
				<button
					class="button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600"
					type="button"
					@click="openExitConfirm"
				>
					<svg
						class="mr-2 text-neutral-400"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
							fill="currentColor"
						/>
						<path
							d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
							fill="currentColor"
						/>
					</svg>
					Thoát
				</button>
			</div>
		</div>
		<div class="relative">
			<div
				aria-hidden="true"
				class="absolute inset-0 flex md:items-center"
			>
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
				>
					Tên biểu mẫu
				</div>
			</div>
		</div>
		<div class="max-w-3xl mx-auto mt-12">
			<div class="flex md-down:flex-col w-full gap-4 md:items-center">
				<div
					class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
				>
					Tên biểu mẫu
				</div>
				<div class="w-3/5 input-group">
					<input
						v-model="name"
						class="title"
						placeholder="Nhập tên biểu mẫu"
						style="border-color: #e8e8e8"
						type="text"
					/>
				</div>
			</div>
		</div>
		<div class="relative mt-10">
			<div
				aria-hidden="true"
				class="absolute inset-0 flex md:items-center"
			>
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
				>
					Nội dung biểu mẫu
				</div>
			</div>
		</div>
		<div class="mt-10 max-w-3xl mx-auto">
			<div class="bg-white rounded-xl border mb-6">
				<div
					class="p-8 py-5 text-lg flex items-center justify-between w-full border-b"
				>
					<div class="font-semibold text-neutral-500">Thông tin</div>
					<div></div>
				</div>
				<div class="p-8 flex flex-col gap-6">
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Logo trung tâm
						</div>
						<div class="w-3/5 flex items-center justify-between">
							<div class="flex items-center justify-center gap-1">
								<svg
									fill="none"
									height="32"
									viewBox="0 0 32 32"
									width="32"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M4 4C4 1.79086 5.79086 0 8 0H18.5858C19.1162 0 19.6249 0.210714 20 0.585786L27.4142 8C27.7893 8.37507 28 8.88378 28 9.41421V28C28 30.2091 26.2091 32 24 32H8C5.79086 32 4 30.2091 4 28V4ZM19 7V3L25 9H21C19.8954 9 19 8.10457 19 7ZM21.7071 15.7071C22.0976 15.3166 22.0976 14.6834 21.7071 14.2929C21.3166 13.9024 20.6834 13.9024 20.2929 14.2929L15 19.5858L12.7071 17.2929C12.3166 16.9024 11.6834 16.9024 11.2929 17.2929C10.9024 17.6834 10.9024 18.3166 11.2929 18.7071L14.2929 21.7071C14.4804 21.8946 14.7348 22 15 22C15.2652 22 15.5196 21.8946 15.7071 21.7071L21.7071 15.7071Z"
										fill="#E5A42B"
										fill-rule="evenodd"
									/>
								</svg>
								<div
									class="text-neutral-500 truncate"
									style="max-width: 140px"
								>
									{{ fileUpload?.name ?? currentOrg.name }}
								</div>
							</div>
							<button
								class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
								type="button"
								@click="openModelUpload"
							>
								<svg
									class="mr-2"
									fill="none"
									height="16"
									viewBox="0 0 16 16"
									width="16"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M8 0C6.57359 0 5.31176 0.560456 4.40576 1.34182C3.63985 2.00237 3.08479 2.8617 2.94223 3.725C1.26586 4.09512 0 5.55511 0 7.31818C0 9.36599 1.70754 11 3.78125 11H7.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11H12.6875C14.5023 11 16 9.56949 16 7.77273C16 6.13656 14.7581 4.80411 13.1657 4.57898C12.9233 1.99944 10.6902 0 8 0Z"
										fill="currentColor"
										fill-rule="evenodd"
									/>
									<path
										clip-rule="evenodd"
										d="M7.5 14.5V11H8.5V14.5C8.5 14.7761 8.27614 15 8 15C7.72386 15 7.5 14.7761 7.5 14.5Z"
										fill="currentColor"
										fill-rule="evenodd"
									/>
								</svg>
								Tải lên ảnh khác
							</button>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Tên trung tâm
						</div>
						<div class="w-3/5 input-group">
							<input
								:disabled="true"
								:value="currentOrg.name"
								placeholder="Nhập tên trung tâm"
								type="text"
							/>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Tiêu đề
						</div>
						<div class="w-3/5 flex gap-4">
							<div class="input-group">
								<input
									v-model="title"
									placeholder="Thông báo học phí"
									type="text"
								/>
							</div>
							<div class="input-group">
								<VueDatepicker
									:disabled="true"
									:max-date="new Date()"
									:min-date="new Date(2023, 1, 0)"
									auto-apply
									class="input-date w-full"
									format="MM/yyyy"
									month-picker
									placeholder="Chọn tháng"
									uid="filter-by-date"
								>
									<template #input-icon>
										<svg
											fill="none"
											height="16"
											viewBox="0 0 16 16"
											width="16"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clip-rule="evenodd"
												d="M4 0.5C4 0.223858 3.77614 0 3.5 0C3.22386 0 3 0.223858 3 0.5V1H2C0.895431 1 0 1.89543 0 3V4H16V3C16 1.89543 15.1046 1 14 1H13V0.5C13 0.223858 12.7761 0 12.5 0C12.2239 0 12 0.223858 12 0.5V1H4V0.5ZM16 14V5H0V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14ZM9.5 7C9.22386 7 9 7.22386 9 7.5V8.5C9 8.77614 9.22386 9 9.5 9H10.5C10.7761 9 11 8.77614 11 8.5V7.5C11 7.22386 10.7761 7 10.5 7H9.5ZM12.5 7C12.2239 7 12 7.22386 12 7.5V8.5C12 8.77614 12.2239 9 12.5 9H13.5C13.7761 9 14 8.77614 14 8.5V7.5C14 7.22386 13.7761 7 13.5 7H12.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H3.5C3.77614 10 4 10.2239 4 10.5V11.5C4 11.7761 3.77614 12 3.5 12H2.5C2.22386 12 2 11.7761 2 11.5V10.5ZM5.5 10C5.22386 10 5 10.2239 5 10.5V11.5C5 11.7761 5.22386 12 5.5 12H6.5C6.77614 12 7 11.7761 7 11.5V10.5C7 10.2239 6.77614 10 6.5 10H5.5Z"
												fill="#94A3B8"
												fill-rule="evenodd"
											/>
										</svg>
									</template>
								</VueDatepicker>
							</div>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Tên Học sinh
						</div>
						<div class="w-3/5 select-tabs">
							<Multiselect
								:allow-empty="false"
								:disabled="true"
								:options="[]"
								:searchable="true"
								deselect-label="Đã chọn"
								label="nameSearch"
								placeholder="Chọn học sinh"
								selectLabel=""
								track-by="id"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>
											{{ props.option.name }}
										</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
				</div>
			</div>
			<div v-for="form in forms" :key="form.id">
				<div class="relative my-6">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex md:items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
						>
							{{ form.title }}
						</div>
					</div>
				</div>
				<div
					v-for="card in form.cards"
					:key="card.id"
					:style="{ opacity: card.disabled ? 0.5 : 1 }"
					class="bg-white rounded-xl border mb-6"
				>
					<div
						class="p-8 py-5 text-lg flex items-center justify-between w-full border-b"
					>
						<div class="font-semibold text-neutral-500">
							{{ card.title }}
						</div>
						<div>
							<button
								v-if="card.canDelete"
								class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
								type="button"
								@click="deleteCard(form, card)"
							>
								<svg
									class="mr-2"
									fill="none"
									height="16"
									viewBox="0 0 16 16"
									width="16"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
										fill="currentColor"
										fill-rule="evenodd"
									/>
								</svg>

								Xoá
							</button>

							<SwitchButton
								v-else
								:value="!card.disabled"
								@click="card.disabled = !card.disabled"
							></SwitchButton>
						</div>
					</div>
					<div class="p-8 flex flex-col gap-6">
						<div
							v-for="field in card.fields"
							:key="field.id"
							class="flex md-down:flex-col w-full gap-4 md:items-center"
						>
							<div
								class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
							>
								{{ field.label }}
							</div>
							<div class="w-3/5 input-group">
								<input
									:id="field.key"
									:disabled="field.disabled"
									:placeholder="field.placeholder"
									v-model="field.value"
									:type="field.type"
									@input="handlePriceInput(field)"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="flex items-center justify-center">
					<button
						class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
						type="button"
						@click="addCard(form)"
					>
						<svg
							class="mr-2 -mt-1"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
								fill="#E5A42B"
								fill-rule="evenodd"
							/>
						</svg>
						<span>Thêm {{ form.title }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="relative mt-10">
			<div
				aria-hidden="true"
				class="absolute inset-0 flex md:items-center"
			>
				<div class="w-full border-t border-neutral-300" />
			</div>
			<div class="relative flex justify-center">
				<div
					class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
				>
					Các thành phần khác
				</div>
			</div>
		</div>
		<div class="mt-10 max-w-3xl mx-auto">
			<div class="bg-white rounded-xl border mb-6">
				<div class="p-8 flex flex-col gap-6">
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Ghi chú cho từng học sinh
						</div>
						<div class="w-3/5 input-group">
							<input
								id="note"
								:disabled="true"
								:placeholder="'Nhập ghi chú riêng cho từng học sinh'"
								v-model="note"
							/>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							GHI CHÚ CHUNG
						</div>
						<div class="w-3/5 flex justify-end">
							<SwitchButton
								:value="enabled_common_note"
								@click="
									enabled_common_note = !enabled_common_note
								"
							/>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Hiển thị mã QR
						</div>
						<div class="w-3/5 flex justify-end">
							<SwitchButton
								:value="enabled_qr_code"
								@click="enabled_qr_code = !enabled_qr_code"
							/>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
						v-if="enabled_qr_code || enabled_common_note"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Chọn thông tin thanh toán
						</div>
						<div class="w-3/5 flex justify-end">
							<Multiselect
								:allow-empty="false"
								:options="listData"
								:searchable="true"
								v-model="selectedTuitionNote"
								track-by="id"
								deselect-label="Đã chọn"
								label="nameSearch"
								placeholder="Chọn thông tin thanh toán"
								selectLabel=""
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>
											{{ props.option.name }}
										</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
					<div
						class="flex md-down:flex-col w-full gap-4 md:items-center"
					>
						<div
							class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-2/5"
						>
							Hiển thị học phí sau giảm giá
						</div>
						<div class="w-3/5 flex justify-end">
							<SwitchButton
								:value="enabled_show_original_price"
								@click="
									enabled_show_original_price =
										!enabled_show_original_price
								"
							/>
						</div>
					</div>
					<!-- <div
						class="
							flex
							md-down:flex-col
							w-full
							gap-4
							md:items-center
						"
					>
						<div
							class="
								uppercase
								text-neutral-400 text-sm
								font-medium
								tracking-wide
								w-2/5
							"
						>
							Hiển thị thống kê chuyên cần
						</div>
						<div class="w-3/5 flex justify-end">
							<SwitchButton />
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import { ACTIONS } from '@/enums/Common';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { $api } from '@/services';
import { _ROUTER_NAME } from '@/enums';
import ExitConfirm from '@/views/formCreate/ExitConfirm.vue';

export default {
	name: 'FeeNoticesCreate',

	components: {
		Multiselect,
		SwitchButton,
		ExitConfirm,
		DaModalFrame,
	},

	data() {
		return {
			modalIsOpen: false,
			name: '',
			title: 'Thông báo học phí',
			modalType: '',
			note: '',
			data: null,
			student_stats: null,
			students: [],
			key: null,
			fileUpload: null,
			forms: [
				{
					id: 1,
					title: 'Khoản thu',
					cards: [
						{
							id: 1,
							title: 'Học can thiệp cá nhân',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'personal_fee_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí thu',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'personal_fee_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ học của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'personal_fee_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền phải đóng',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
						{
							id: 2,
							title: 'Học can thiệp lớp nhóm',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'group_fee_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí thu',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'group_fee_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ học của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'group_fee_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền phải đóng',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
						{
							id: 3,
							title: 'Học bán trú',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'boarding_fee_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí thu',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'boarding_fee_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ học của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'boarding_fee_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền phải đóng',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
						{
							id: 4,
							title: 'Phí sử dụng sổ nhật ký điện tử',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'app_fee_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí thu',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'app_fee_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ học của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'app_fee_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền phải đóng',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
					],
				},
				{
					id: 2,
					title: 'Hoàn phí',
					cards: [
						{
							id: 1,
							title: 'Học can thiệp cá nhân',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'personal_fee_back_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí hoàn',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'personal_fee_back_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ nghỉ của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'personal_fee_back_3',
									name: 'personal_fee_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền được hoàn trả',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
						{
							id: 2,
							title: 'Học can thiệp lớp nhóm',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'group_fee_back_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí hoàn',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'group_fee_back_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ nghỉ của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'group_fee_back_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền được hoàn trả',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
						{
							id: 3,
							title: 'Học bán trú',
							disabled: true,
							canDelete: false,
							fields: [
								{
									id: 1,
									key: 'boarding_fee_back_1',
									type: 'text',
									placeholder: 'Nhập chi phí',
									label: 'Chi phí hoàn',
									value: '',
									disabled: true,
								},
								{
									id: 2,
									key: 'boarding_fee_back_2',
									type: 'text',
									placeholder:
										'Hệ thống đếm số giờ nghỉ của học sinh',
									label: 'Số lượng',
									value: '',
									disabled: true,
								},
								{
									id: 3,
									key: 'boarding_fee_back_3',
									type: 'text',
									placeholder:
										'Hệ thống tính số tiền được hoàn trả',
									label: 'Thành tiền',
									value: '',
									disabled: true,
								},
							],
						},
					],
				},
			],
			enabled_common_note: false,
			enabled_qr_code: false,
			enabled_show_original_price: false,
			listData: [],
			selectedTuitionNote: null,
		};
	},

	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},

		formId() {
			return this.$route.query.id;
		},

		checkEdit() {
			return this.$route.query.edit;
		},

		currentOrg() {
			return this.$store.state.profile.current_org;
		},

		profile() {
			return this.$store.state.profile;
		},

		type() {
			return ACTIONS;
		},
	},

	created() {
		if (this.checkEdit) {
			const saveForm = window.sessionStorage.getItem('saveForm');
			if (saveForm) {
				let data = JSON.parse(saveForm);
				this.name = data.name;
				this.title = data.title;
				this.forms = data.forms;
				this.enabled_qr_code = data.enabled_qr_code;
				this.enabled_common_note = data.enabled_common_note;
				this.enabled_show_original_price =
					data.enabled_show_original_price;
			}
		} else {
			if (this.formId) this.getTemplateData();
			else this.fetchData();
		}
		this.getTuitionNote();
	},

	methods: {
		async fetchData() {
			this.isLoading = true;
			try {
				const {
					data: { data },
				} = await $api.org.getTuitionFee();
				this.data = data;
				this.forms[0].cards[0].fields[0].value =
					this.$filters.priceFormat(data.personal_price);
				this.forms[0].cards[1].fields[0].value =
					this.$filters.priceFormat(data.group_class_price);
				this.forms[0].cards[2].fields[0].value =
					this.$filters.priceFormat(data.day_care_price);
				this.forms[0].cards[3].fields[0].value =
					this.$filters.priceFormat(data.app_price);
				this.forms[1].cards[0].fields[0].value =
					this.$filters.priceFormat(data.personal_price);
				this.forms[1].cards[1].fields[0].value =
					this.$filters.priceFormat(data.group_class_price);
				this.forms[1].cards[2].fields[0].value =
					this.$filters.priceFormat(data.day_care_price);
				
				if (!this.formId) {
					for (let form of this.forms) {
						for (let card in form.cards) {
							if (
								this.onlyNumbers(
									form.cards[card].fields[0].value
								) > 0
							) {
								form.cards[card].disabled = false;
							}
						}
					}
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.isLoading = false;
			}
		},
		async getTemplateData() {
			this.isLoading = true;
			try {
				const res = await $api.org.getTemplateData(this.formId);
				let data = res.data.data;
				this.name = data.name;
				this.title = data.title;
				this.selectedTuitionNote = data.tuition_common_note;
				this.forms[0].cards[0].disabled = !data.enabled_personal_fee;
				this.forms[0].cards[1].disabled = !data.enabled_group_class_fee;
				this.forms[0].cards[2].disabled = !data.enabled_day_care_fee;
				this.forms[0].cards[3].disabled = !data.enabled_app_fee;
				this.forms[1].cards[0].disabled = !data.enabled_personal_refund;
				this.forms[1].cards[1].disabled =
					!data.enabled_group_class_refund;
				this.forms[1].cards[2].disabled = !data.enabled_day_care_refund;
				this.enabled_qr_code = data.enabled_qr_code;
				this.enabled_common_note = data.enabled_common_note;
				this.enabled_show_original_price =
					data.enabled_show_original_price;
				if (data.additional_tuition_pricing.length > 0) {
					data.additional_tuition_pricing.map((i) => {
						if (i.type == 'fee')
							this.addCard(
								this.forms[0],
								i.name,
								String(i.price)
							);
						if (i.type == 'refund')
							this.addCard(
								this.forms[1],
								i.name,
								String(i.price)
							);
					});
				}
				await this.fetchData();
			} catch (error) {
				console.log(error);
			} finally {
				this.isLoading = false;
			}
		},
		async getTuitionNote() {
			try {
				const res = await $api.org.getTuitionNote();
				if (res) {
					this.listData = res.data.data;
				}
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
		openModal() {
			this.modalType = this.type.CREATE;
			this.modalIsOpen = true;
		},

		cancel() {
			this.modalIsOpen = false;
			this.modalType = '';
		},

		async submit(redirect = true) {
			this.modalIsOpen = false;
			this.modalType = '';
			let additional_tuition_pricing = [];
			for (let form of this.forms) {
				for (let card of form.cards) {
					if (
						card.fields[0].value &&
						this.onlyNumbers(card.fields[1].value) > 0 &&
						(card.type === 'fee' || card.type === 'refund')
					) {
						additional_tuition_pricing.push({
							name: card.fields[0].value,
							price: this.onlyNumbers(card.fields[1].value) || 0,
							// count: this.onlyNumbers(card.fields[2].value) || 0,
							type: card.type,
							// total:
							// 	this.onlyNumbers(card.fields[1].value) *
							// 		this.onlyNumbers(card.fields[2].value) || 0,
						});
					}
				}
			}
			const payload = {
				additional_tuition_pricing: additional_tuition_pricing,
				tuition_template: {
					enabled_personal_fee: !this.forms[0].cards[0].disabled,
					enabled_group_class_fee: !this.forms[0].cards[1].disabled,
					enabled_day_care_fee: !this.forms[0].cards[2].disabled,
					enabled_app_fee: !this.forms[0].cards[3].disabled,
					enabled_day_care_refund: !this.forms[1].cards[2].disabled,
					enabled_group_class_refund:
						!this.forms[1].cards[1].disabled,
					enabled_personal_refund: !this.forms[1].cards[0].disabled,
					enabled_qr_code: this.enabled_qr_code,
					enabled_show_original_price:
						this.enabled_show_original_price,
					enabled_common_note: this.enabled_common_note,
					name: this.name,
					title: this.title,
					tuition_common_note_id: this.selectedTuitionNote?.id,
				},
				tuition_template_photo: {
					asset_key: this.key ?? this.currentOrg?.org_id,
				},
			};
			try {
				if (this.formId) {
					await $api.org.updateForm(this.formId, payload);
					this.$store.dispatch('setAlertMessage', {
						type: 'success',
						message: 'Chỉnh sửa biểu mẫu thành công',
					});
				} else {
					await $api.org.createForm(payload);
					this.$store.dispatch('setAlertMessage', {
						type: 'success',
						message: 'Tạo biểu mẫu thành công',
					});
				}
				if (redirect) {
					this.$router.push({
						name: _ROUTER_NAME.TUITION_FORMS,
					});
				}
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		addCard(form, name, price) {
			const newCard = {
				id: form.cards.length + 1,
				title: `${form.title} khác (${
					form.id === 1
						? form.cards.length - 3
						: form.cards.length - 2
				})`,
				disabled: false,
				canDelete: true,
				type: form.id === 1 ? 'fee' : 'refund',
				fields: [
					{
						id: 1,
						type: 'text',
						key: `${form.id === 1 ? '' : '_back'}_fee_other_1_${
							form.cards.length + 1
						}`,
						placeholder: `Tên ${form.title}`,
						label: `Tên ${form.title}`,
						value: name ? name : '',
						disabled: false,
					},
					{
						id: 2,
						key: `${form.id === 1 ? '' : '_back'}_fee_other_2_${
							form.cards.length + 1
						}`,
						type: 'text',
						placeholder: `Nhập chi phí ${
							form.id === 1 ? 'phải đóng' : 'hoàn trả'
						}`,
						label: `Chi phí ${form.id === 1 ? 'thu' : 'hoàn'}`,
						value: price ? price : '0',
						disabled: false,
					},
					// {
					// 	id: 3,
					// 	key: `${form.id === 1 ? '' : '_back'}_fee_other_3_${
					// 		form.cards.length + 1
					// 	}`,
					// 	type: 'text',
					// 	placeholder: 'Nhập số lượng',
					// 	label: 'Số lượng',
					// 	value: '',
					// 	disabled: false,
					// },
					// {
					// 	id: 4,
					// 	key: `${form.id === 1 ? '' : '_back'}_fee_other_4_${
					// 		form.cards.length + 1
					// 	}`,
					// 	type: 'text',
					// 	placeholder: `Hệ thống tính số tiền ${
					// 		form.id === 1 ? 'phải đóng' : 'được hoàn trả'
					// 	}`,
					// 	label: 'Thành tiền',
					// 	value: '',
					// 	disabled: true,
					// },
				],
			};
			form.cards.push(newCard);
		},

		deleteCard(form, card) {
			const index = form.cards.findIndex((el) => el.id === card.id);
			form.cards.splice(index, 1);
		},

		openModelUpload() {
			const target = document.getElementById(
				'upload-images-notification'
			);
			target ? target.click() : '';
		},

		isImage(icon) {
			const ext = ['.jpg', '.jpeg', '.png', '.svg'];
			return ext.some((el) => icon.toLowerCase().endsWith(el));
		},

		uploadChange(event) {
			let fileUploads = Array.from(event?.target?.files || []);
			if (!fileUploads?.length || !this.isImage(fileUploads[0].name)) {
				return;
			}
			this.fileUpload = fileUploads[0];
			this.closeUpload();
		},

		closeUpload() {
			const target = document.getElementById(
				'upload-images-notification'
			);
			target ? (target.value = null) : '';
		},

		async getSignatures() {
			const {
				data: { data },
			} = await this.$api.file.getSignatures({
				mime_types: this.fileUpload?.type,
				prefix: 'notice_attachment',
			});

			if (data && data.length) {
				let formData = new FormData();
				formData.append(
					'AWSAccessKeyId',
					data[0]['AWSAccessKeyId'] || ''
				);
				formData.append('key', this.fileUpload.key || '');
				formData.append('acl', this.fileUpload.acl || '');
				formData.append(
					'Content-Type',
					this.fileUpload['Content-Type'] || ''
				);
				formData.append(
					'x-amz-signature',
					this.fileUpload.signature || ''
				);
				formData.append('Signature', this.fileUpload.signature || '');
				formData.append('Policy', this.fileUpload.policy || '');
				formData.append(
					'success_action_status',
					this.fileUpload.success_action_status || ''
				);
				formData.append('file', this.fileUpload);
				await this.uploadToS3(
					this.fileUpload.action,
					formData,
					this.fileUpload
				);
			}
		},

		async uploadToS3(url, payload, file) {
			const { data } = await this.$api.file.uploadToS3(url, payload);
			const keyData = data.toString().match('<Key>(.*)</Key>');
			const key = keyData && keyData.length ? keyData[1] : '';
			if (key) {
				this.key = {
					asset_key: key,
					mime_type: file.type,
					name: file.name,
				};
			}
		},

		preview() {
			if (this.formId) this.submit(false);
			let newForm = [];
			this.forms.forEach((i) => {
				newForm.push({
					id: i.id,
					name: i.title,
					cards: i.cards.map((c) => ({
						id: c.id,
						title: c.type ? c.fields[0].value : c.title,
						price: c.fields[c.type ? 1 : 0].value,
						disabled: c.disabled,
					})),
				});
			});
			window.sessionStorage.setItem(
				'saveForm',
				JSON.stringify({
					name: this.name,
					title: this.title,
					tuition: this.selectedTuitionNote,
					enabled_qr_code: this.enabled_qr_code,
					enabled_show_original_price:
						this.enabled_show_original_price,
					enabled_common_note: this.enabled_common_note,
					forms: this.forms,
				})
			);
			window.sessionStorage.setItem(
				'formPreview',
				JSON.stringify({
					name: this.name,
					title: this.title,
					tuition: this.selectedTuitionNote,
					enabled_qr_code: this.enabled_qr_code,
					enabled_show_original_price:
						this.enabled_show_original_price,
					enabled_common_note: this.enabled_common_note,
					forms: newForm,
				})
			);
			this.$router.push({
				name: _ROUTER_NAME.TUITION_FORMS_PREVIEW,
			});
		},

		openExitConfirm() {
			this.modalType = this.type.DELETE;
			this.modalIsOpen = true;
		},

		exit() {
			this.modalIsOpen = false;
		},
		back() {
			this.$router.push(`/tuition/forms`);
		},

		onlyNumbers(text) {
			return Number(text.replace(/\./g, ''));
		},

		handlePriceInput(element) {
			if (element.id === 1 || element.type === 'number') return;
			let formattedNumber = String(element.value);
			formattedNumber = formattedNumber.replace(/\D/g, '');
			formattedNumber = formattedNumber.replace(/^0+/, '');
			formattedNumber = formattedNumber.replace(
				/\B(?=(\d{3})+(?!\d))/g,
				'.'
			);
			element.value = formattedNumber;
		},
	},
};
</script>

<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
</style>
